// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"5453d036","378":"54a9a310","485":"e97d52d3","578":"44b90b2d","750":"44b90b2d","795":"54a9a310"}[chunkId] + ".chunk.css";
};